import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from '@assetmark/ui-components';
import styles from './FooterSkeleton.module.scss';
const FOOTER_STYLES = {
    container: {
        height: '43px',
    },
    copyrightCol: {
        width: '220px',
    },
    linksCol: {
        gap: '1rem',
    },
    linksContainer: {
        gap: '1rem',
    },
    linkItem: {
        width: '105px',
    },
};
export const FooterSkeleton = () => {
    return (_jsxs("div", { className: styles.footer, style: FOOTER_STYLES.container, children: [_jsx("div", { className: styles.footerLeft, children: _jsx(Skeleton, { style: FOOTER_STYLES.copyrightCol }) }), _jsx("div", { className: styles.footerRight, style: FOOTER_STYLES.linksCol, children: new Array(2).fill(0).map((item, idx) => (_jsx("div", { style: FOOTER_STYLES.linkItem, children: _jsx(Skeleton, {}) }, idx))) })] }));
};
